import { gql } from '@graphql/__generated__';

export const GET_BUYER_LEAD_STAGES = gql(/* GraphQL */ `
  query GetBuyerLeadStages {
    lead_stages(
      where: {
        pipeline: { name: { _eq: "house_sales" }, lead_type: { _eq: "buyer" } }
      }
      order_by: { order_nr: asc }
    ) {
      id
      name
      label
      status
    }
  }
`);

export const CREATE_BUYER_LEAD = gql(/* GraphQL */ `
  mutation createBuyerLead($buyerLead: buyer_leads_insert_input!) {
    insert_buyer_leads_one(object: $buyerLead) {
      id
      ...BuyerLeadDnDColumn
    }
  }
`);

export const INSERT_BUYER_LEADS_MANY = gql(/* GraphQL */ `
  mutation InsertBuyerLeadsMany($buyer_leads: [buyer_leads_insert_input!]!) {
    insert_buyer_leads(objects: $buyer_leads) {
      returning {
        id
        user_id
        lot_id
        development_id
      }
    }
  }
`);

export const BUYER_LEAD_FEED = gql(/* GraphQL */ `
  query BuyerLeadFeed($buyer_lead_id: uuid!, $limit: Int = 200) {
    activities(
      where: {
        buyer_lead_id: { _eq: $buyer_lead_id }
        _or: [
          { activity_type: { _neq: change } }
          { lot_id: { _is_null: false } }
        ]
      }
      order_by: [{ pinned: desc }, { created_at: desc }]
      limit: $limit
    ) {
      ...ActivityItem
      ...ActivityFiltersActivity
    }
  }
`);
